import styled from "@emotion/styled";
import { BACKGROUND_GRAY_COLOR_NAME, BRAND_PRIMARY_YELLOW, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import Colors from "styles/colors";
export const StyledPositionComponent = styled.a`
  display: flex;
  font-weight: 400;
  text-decoration: none;
  color: black;
  cursor: pointer;
  align-items: center;
  padding: 24px 12px;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};

    .arrow-container {
      left: 8px;
    }
  }

  .position-name {
    flex: 1;
  }

  .tags {
    flex: 1;
    display: flex;
    gap: 8px;
  }

  .arrow-container {
    position: relative;
    left: 0;
    transition: left 0.3s ease-in-out;
    justify-self: flex-end;
  }

  .internal-tag {
    display: flex;
    align-items: center;
    background-color: ${Colors[BRAND_PRIMARY_YELLOW]};
    color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
    font-size: 0.875rem;
    font-weight: 400;
    padding: 0px 8px;
    border-radius: 4px;
    vertical-align: middle;
  }
`;
